const LinkIcon = () =>{
    return(
        <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.8333 25.3327H11.0833C7.58553 25.3327 4.75 22.4972 4.75 18.9993V18.9993C4.75 15.5015 7.58553 12.666 11.0833 12.666H15.8333" stroke="#D0D0D0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M25.3334 19H12.6667" stroke="#D0D0D0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M22.1667 25.3327H26.9167C30.4145 25.3327 33.25 22.4972 33.25 18.9993V18.9993C33.25 15.5015 30.4145 12.666 26.9167 12.666H22.1667" stroke="#D0D0D0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )
} 
export default LinkIcon